export const PostHogEvents = {
  USER_SIGNED_UP: 'user_signed_up',
  User_SIGNUP_FAILED: 'user_signup_failed',
  USER_LOGGED_IN: 'user_logged_in',
  User_LOGIN_FAILED: 'user_login_failed',
  FORM_SUBMITTED: 'form_submitted',
  USER_LOGGED_OUT: 'user_logged_out',
  USER_FORGOT_PASSWORD: 'user_forgot_password',
  FORGET_PASSWORD_INVALID_EMAIL: 'forget_password_invalid_email',
  FORGET_PASSWORD_REQUESTED: 'password_reset_requested',
  FORGET_PASSWORD_FAILED: 'forget_password_failed',
  PASSWORD_RESET_SUCCESS: 'password_reset_success',
  FORM_SECTION_VIEWED: 'form_section_viewed',
  FORM_FIELD_FOCUSED: 'form_field_focused',
  FORM_PROGRESS_SAVED: 'form_progress_saved',
  PAGE_VIEWED: 'page_viewed',
  POPUP_OPEN: 'popup_open',
  FORM_PROGRESS_SAVED_FAILED: 'form_progress_saved_failed',
  DISCARD_CHANGES_POPUP: 'discard_changes_popup',
  TAB_CHANGED: 'tab_changed',
  MODAL_OPENED: 'modal_opened',
  MODAL_CLOSED: 'modal_closed',
  VERIFICATION_EMAIL_SENT: 'verification_email_sent',
  EMAIL_VERIFIED: 'email_verified',
  TOOLTIP_OPENED: 'tooltip_opened',

  // Add more as needed
};
